export const EDITOR_TYPES = {
  email: {
    label: "Email",
    channel: "email",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  sms: {
    label: "SMS",
    channel: "sms",
    htmlCapable: false,
    defaultOutputFormat: "text",
  },
  note: {
    label: "Note",
    channel: "note",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  log_email: {
    label: "Log Email",
    channel: "email",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  phone_call: {
    label: "Phone Call",
    channel: "phone_call",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  log_text: {
    label: "Log Text",
    channel: "sms",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  log_appointment: {
    label: "Log Appointment",
    channel: "appointment",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  task: {
    label: "Task",
    channel: "task",
    htmlCapable: false,
    defaultOutputFormat: "text",
  },
  appointment: {
    label: "Appointment",
    channel: "appointment",
    htmlCapable: false,
    defaultOutputFormat: "text",
  },
  landing_page: {
    label: "Landing Page",
    channel: "landing_page",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  signature: {
    label: "Signature",
    channel: "signature",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
  job_posting: {
    label: "Job Posting",
    channel: "job_posting",
    htmlCapable: true,
    defaultOutputFormat: "text",
  },
};

// Maps activityType prop values (from lead drawer forms) to EDITOR_TYPES keys.
// ActivityEditor receives activityType from parent forms (e.g., "text_message", "email")
// which don't match EDITOR_TYPES keys directly.
export const ACTIVITY_TYPE_TO_EDITOR_TYPE = {
  text_message: "log_text",
  direct_text_message: "sms",
  email: "log_email",
  direct_email: "email",
  // These map 1:1 and are included for completeness:
  note: "note",
  phone_call: "phone_call",
  log_appointment: "log_appointment",
  appointment: "appointment",
  task: "task",
};

export const VARIABLE_ENABLED_ACTIVITY_TYPES = [
  "note",
  "phone_call",
  "text_message",
  "email",
  "log_appointment",
  "appointment",
];

export const supportsActivityVariables = (activityType) =>
  VARIABLE_ENABLED_ACTIVITY_TYPES.includes(activityType);

export const OUTPUT_FORMATS = {
  TEXT: "text",
  HTML: "html",
};

export const FORMAT_STORAGE_KEY = "ai_assist_output_format";

export default EDITOR_TYPES;
